<template>
  <div>
    <div class="tasksTab">
      <div class="dates-wrap">
        <h5 class="dates"></h5>
        <div class="create-note">
          <button v-if="this.$route.params.organization_id" class="btn" @click="showCreateTask">Add Task</button>
        </div>
      </div>
      <div id="accordion" class="hide-scroll taskScrollWrapper">
        <div class=" mb-2" v-for="(task, index) in tasksList" :key="task.id">
          <div class="accordion-item accordion-wrap">
            <div class="card-header">
              <h5 class="mb-0 accordion-header" :id="'headingNine'+index">
                <button
                    class="btn btn-link "
                    data-toggle="collapse"
                    aria-expanded="true"
                    :aria-controls="'collapseTaskNine' + index"
                    @click="toggleMenu('headingNine' + index)"
                    :class="{
                        collapsed: activeMenuId === 'headingNine' + index 
                      }"
                >
                  <div class="container-fluid accordion-button-content">
                    <div class="accordion-heading-wrap">
                      <div class="accordion-arrow-wrap">
                        <h5 class="accordion-heading">
                          {{ task.title && task.title.length > 100 ? `${task.title.substring(0, 70)}` : task.title }}
                          <span class="buttonBadge">TO-DO</span>
                        </h5>
                        <div class="d-flex">
                          <h5 class="accordion-para"
                              v-html="task.description && task.description.length > 100 ? `${task.description.substring(0, 70)}` : task.description">
                          </h5>
                          <span class="atTags ml-1"> @{{ task.assigned_to.name }}</span>
                        </div>
                      </div>
                      <div class="accordion-time-wrap taskDateTime">
                        <div class="taskBadgeWrapper">
                          <span class="taskBadge" :class="task.status === 0 ? 'pending' : 'completed'">{{
                              task.status === 0 ? 'Pending' : 'Completed'
                            }}</span>
                        </div>
                        <div class="accordion-time pendingTime"
                             :class="[task.status === 0 ? 'pendingTime' : 'completedTime', activeMenuId === 'headingNine' + index ? 'd-none' : '']">
                          <h5 class="dateHeading">Due:</h5>
                          <h5 class="time-span">{{ task.due_date }} {{ task.time }}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </button>
                <button class="ml-2 delete-btn-wrapper" :class="{'d-none': activeMenuId != 'headingNine' + index}" @click.prevent="deleteTask(task.id)">
                  <i class="fa fa-trash-o mr-1" aria-hidden="true"></i>delete
                </button>
              </h5>
              <div
                  :id="'collapseTaskNine' + index"
                  class="accordion-collapse collapse"
                  :aria-labelledby="'headingNine'+index"
                  data-parent="#accordion"
                  :class="{
                        show: activeMenuId === 'headingNine' + index ,  
                      }"
              >
                <div class="card-body">
                  <h5 class="card-heading mt-4">Description</h5>
                  <p class="card-para" v-html="task.description"></p>
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="card-heading">Due Date</h5>
                      <p class="card-para">{{ task.due_date }} {{ task.time }}</p>
                    </div>
                    <div class="col-md-6">
                      <h5 class="card-heading">Assign To</h5>
                      <p class="card-para">{{ task.assigned_to.name }}</p>
                    </div>
                  </div>
                  <h5 class="card-heading">Status</h5>
                  <p class="card-para">{{ task.status === 0 ? "Pending" : "Completed" }}</p>

                  <div class="notesButtonWrapper mb-2">
                    <button class="addEditNotes editButtonNotes" @click.prevent="editTask(task.id)">
                      <img :src="pencilEdit" alt=""/>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import pencilEdit from "@/assets/images/pencil-edit.svg";
import editIcon from "@/assets/images/edit2.svg";
import deleteIcon from "@/assets/images/delete.svg";

export default {
  name: "TasksTab",
  props: {
    showCreateTask: {
      type: Function,
    },
    tasksList: []
  },
  data() {
    return {
      activeMenuId: null,
      deleteIcon: deleteIcon,
      editIcon: editIcon,
      pencilEdit: pencilEdit,
    };
  },


  methods: {
    editTask(id) {
      this.$emit('editable', id);
    },

    deleteTask(task) {
      this.$store.dispatch("message/update", {
        title: task.title,
        body: "Are you sure you want to delete this Task?",
        class: "danger",
        confirm: true,
      });

      this.$bus.$off("proceed");
      this.$bus.$once("proceed", () => {
        this.delete(task);
        this.$store.dispatch("message/close");
      });
    },

    delete(task) {
      this.showskLoader = true;
      this.$store
          .dispatch("quick_task/delete", task)
          .then((message) => {
            this.showskLoader = false;
            this.$toast.success(message);
            this.$parent.getRecords();
          })
          .catch((error) => {
            // send error message
            false
            this.$store.dispatch(
                "message/update",
                {
                  title: task.title,
                  class: "danger",
                  body: error.response.data.message,
                  errors: error.response.data.errors,
                  confirm: false,
                },
                {root: true}
            );
          });
    },

    toggleMenu(menuId) {
      this.activeMenuId = this.activeMenuId === menuId ? null : menuId;
    },
  }
};
</script>
